const realmBase = process.env.REACT_APP_KC_REALM_BASE || "https://meotrikapm.com/sso/realms/DEV-REALM";
const clientId = process.env.REACT_APP_KC_CLIENT_ID || "kt-admin-app";
const redirectUri = process.env.REACT_APP_OIDC_REDIRECT_URI || "https://backoffice.kejartugas.com/";
const postLogoutRedirectUri = process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI || "https://backoffice.kejartugas.com";

export const oidcConfig = {
  authority: realmBase,
  client_id: clientId,
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri: postLogoutRedirectUri,
  automaticSilentRenew: true,
  loadUserInfo: true,
  includeIdTokenInSilentRenew: true,
  filterProtocolClaims: true,
  // Provide metadata explicitly to avoid discovery fetch (which can be blocked by CORS)
  metadata: {
    issuer: realmBase,
    authorization_endpoint: `${realmBase}/protocol/openid-connect/auth`,
    token_endpoint: `${realmBase}/protocol/openid-connect/token`,
    userinfo_endpoint: `${realmBase}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${realmBase}/protocol/openid-connect/logout`,
    revocation_endpoint: `${realmBase}/protocol/openid-connect/revoke`,
    introspection_endpoint: `${realmBase}/protocol/openid-connect/token/introspect`,
    jwks_uri: `${realmBase}/protocol/openid-connect/certs`,
    check_session_iframe: `${realmBase}/protocol/openid-connect/login-status-iframe.html`
  }
};
